import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class CheckridesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  create(params, router) {
    const url = "/api/checkrides";
    return this.CommonAPIService.postCall(url, params, router);
  }

  update(id, params, router) {
    const url = `/api/checkrides/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  get(router) {
    const url = "/api/checkrides";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getById(id, router) {
    const url = `/api/checkrides/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getResultStatusOptions(router) {
    const url = "/api/checkrides/resultStatusOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }

  sendDpeEmail(userId, params, router) {
    const url = `/api/checkrides/dpeEmail/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  sendStudentEmail(userId, params, router) {
    const url = `/api/checkrides/studentEmail/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }
}
export default CheckridesAPIService;
